import { useEthers } from '@usedapp/core';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';

interface WalletsModalProps {
  open: boolean;
  onClose: () => void;
}

export const WalletsModal = ({ open, onClose } : WalletsModalProps) => {

  const { activateBrowserWallet } = useEthers();

  const activateMetaMask = () => {
    activateBrowserWallet({ type: 'metamask' });
    onClose();
  };

  const activateCoinbase = () => {
    activateBrowserWallet({ type: 'coinbase' });
    onClose();
  };

  const activateWalletConnect = () => {
    activateBrowserWallet({ type: 'walletConnectV2' });
    onClose();
  };


  

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="account-dialog-title"
      PaperProps={{sx:{bgcolor:'#0c0c13'}}}
      maxWidth="xs"
    >
      <DialogTitle id="account-dialog-title" style={{color:"#fff"}}>
        Connect Your Wallet
        <IconButton size='small' onClick={onClose} sx={{color: '#fff'}} style={{
          position: 'absolute',
          right: 10,
          top: 10,
          background: 'none',
          boxShadow: 'none'
        }}>
          <CloseIcon style={{color: '#000 !important'}}/>
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{width: '275px'}}>
          <Grid item xs={12} justifyContent='center' display='flex'>
            <Card sx={{ minWidth: 250 }}>
              <CardActionArea onClick={activateMetaMask}>
                <CardMedia
                  component="img"
                  height='100'
                  image="https://buytruth.cc/wp-content/uploads/2023/10/MetaMask_Fox.png"
                  alt="MetaMask"
                />
                <CardContent sx={{padding: 0}}>
                  <Typography gutterBottom variant="h5" component="div" sx={{textAlign:'center'}} >
                    MetaMask
                  </Typography>
                  
                </CardContent>
              </CardActionArea>
            </Card>
            
          </Grid>
          <Grid item xs={12} justifyContent='center' display='flex'>
            <Card sx={{ maxWidth: 250 }}>
              <CardActionArea onClick={activateCoinbase}>
                <CardMedia
                  component="img"
                  height="100"
                  image="https://buytruth.cc/wp-content/uploads/2023/10/coinbase_wallet.png"
                  alt="Coinbase Wallet"
                />
                <CardContent sx={{padding: 0}}>
                  <Typography gutterBottom variant="h5" component="div" sx={{textAlign:'center'}}>
                    Coinbase Wallet
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
            
          </Grid>
          <Grid item xs={12} justifyContent='center' display='flex'>
            <Card sx={{ maxWidth: 250 }}>
              <CardActionArea onClick={activateWalletConnect}>
                <CardMedia
                  component="img"
                  height="100"
                  image="https://buytruth.cc/wp-content/uploads/2023/10/walletConnect.png"
                  alt="WalletConnect"
                />
                <CardContent sx={{padding: 0}}>
                  <Typography gutterBottom variant="h5" component="div" sx={{textAlign:'center'}}>
                    WalletConnect
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
            
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}